module.exports = __webpack_public_path__ + "media/images/icons/business-7809c56d32d50ae5284907c15fcf1741.svg";